import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import miscFunctions from '../../helpers/misc-functions';
import BaseComponent from '../../baseClasses/BaseComponent';
import PopupMenu from '../../components/PopupMenu';
import MultiTabUserSelectPopup from '../../components/MultiTabUserSelectPopup';
import UserAvatar from '../../components/UserAvatar';
import emailDecoration from '../../assets/images/email-icon-gray.svg';
import caret from '../../assets/images/caret.svg';
import './SelectUserComboBox.scss';
import { normalizeData } from '../../models';
import userService from '../../services/userService';
import { userDescriptor } from '../../containers/Directory/Users';
import Input from '../Input';
export class SelectUserComboBox extends BaseComponent {

  constructor(props) {
    super(props);
    SelectUserComboBox.propTypes = {
      width: PropTypes.number,
      height: PropTypes.number,
      hasBorder: PropTypes.bool,
      multiSelect: PropTypes.bool,
      menuBelow: PropTypes.bool,
      useMultiTab: PropTypes.bool,
      small: PropTypes.bool,
      dontFocus: PropTypes.bool, //if true, the combobox will not be focused initially, avoiding an auto-scroll
      displayFontStyle: PropTypes.object,
      users: PropTypes.arrayOf(PropTypes.object),
      selectedUsers: PropTypes.arrayOf(PropTypes.object),
      handleMultipleSelection: PropTypes.func,
    };
    this.getFilteredUsers = this.getFilteredUsers.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.filterUserList = this.filterUserList.bind(this);
    this.handleSearchValue = this.handleSearchValue.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.createMenuItems = this.createMenuItems.bind(this);
    this.createComboBoxMenu = this.createComboBoxMenu.bind(this);
    this.handleMultiMenuSelection = this.handleMultiMenuSelection.bind(this);
    this.handleComboboxMenuSelection = this.handleComboboxMenuSelection.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      selected: false,
      usersList: props.users || [],
    };
  }

  componentDidMount() {
    if (!this.props.dontFocus) {
      this.setFocus();
    }
    if(this.props.closeOnOutSideClick){
      document.addEventListener('click', this.handleClickOutside, false);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedUsers != this.props.selectedUsers) {
      this.createComboBoxMenu();
    }
    if(prevProps.users != this.props.users){
      this.setState({ usersList: this.props.users });
    }
  }

  setFocus() {
    if (this.comboBox) {
      this.comboBox.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
      if (!this.props.showSearchBar) {
        this.comboBox.focus();
      }
    }
  }

  filterUserList(users, type) {
    const { filterUsers, currentUser, currentCompany, permissions } = this.props;
    let usersFiltered = null;

    if (users && users.length > 0) {
      if (filterUsers) {
        usersFiltered = users.filter(user => {
          if (miscFunctions.isEmpty(user)) {
            return false;
          }
          if (currentUser && user.id == currentUser.id && permissions && permissions.isSuperUser) {
            return false;
          }
          const isFiltered = filterUsers.filter(filterUser => {
            if (type) {
              if (type == 'company_users' && filterUser.companies && filterUser.companies.length > 0 && currentCompany && filterUser.companies[0].id == currentCompany.id) {
                return (filterUser && filterUser.user ? filterUser.user.id == user.id : filterUser.id == user.id);
              }
              else if (type == 'vendor_users' && currentCompany && filterUser.companies[0].id != currentCompany.id) {
                return (filterUser && filterUser.user ? filterUser.user.id == user.id : filterUser.id == user.id);
              }
              else if (type == 'all') {
                return filterUser && filterUser.user ? filterUser.user.id == user.id : filterUser.id == user.id;
              }
              else {
                return false;
              }
            }
            else {
              return filterUser && filterUser.user ? filterUser.user.id == user.id : filterUser.id == user.id;
            }
          });
          return isFiltered.length == 0;
        }
        );
      }
      else {
        usersFiltered = users.filter(user => {
          if (miscFunctions.isEmpty(user)) {
            return false;
          }
          // if (this.props.useMultiTab) {
          //   if (user.role && user.role.name == "standard_user") {
          //     return false
          //   }
          // }
          if (currentUser && user.id == currentUser.id && permissions && permissions.isSuperUser) {
            return false;
          }
          else {
            if (type) {
              if (type == 'company_users' && user.companies && user.companies.length && currentCompany && (user.companies[0].id == currentCompany.id || user.companies[0] == currentCompany.id)) {
                return true;
              }
              else if (type == 'vendor_users' && user.companies && user.companies.length && currentCompany && user.companies[0].id != currentCompany.id) {
                return true;
              }
              else if (type == 'all') {
                return true;
              }
              else {
                return false;
              }
            }
            else {
              return true;
            }
          }
        });
      }
    }
    return usersFiltered;
  }

  handleCloseMenu(type, esc) {
    if(this.state.menu){
      this.setState({
        menu: null,
      });
      this.setFocus();
    }
  }

  handleClickOutside(event) {
    if (this.comboBoxRef && !this.comboBoxRef.contains(event.target) &&
     !((event.target.tagName === 'DIV' && event.target.className === 'outer-popup-container show-search-bar')
     || (event.target.tagName === 'INPUT' && event.target.className === 'search-input'))) {
      this.setState({
        usersList: this.props.users });
      this.handleCloseMenu();
    }
  }

  componentWillUnmount(){
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  handleSearchUsers(users){
    this.setState({
      usersList: users,
    }, () => {
      const menu = this.createComboBoxMenu(this.tempInitialValue);
      this.setState({ menu: menu });
    });
  }

  getFilteredUsers(users){
    const _this = this;
    return users.filter(function(user) {
      let userMarkets=user.markets;
      let usmarket=userMarkets.map(market=>{  //validate market 
        return _this.props.actualMarket.map(function(markets){     
          if (markets.code==market.code){
            return true;
          }
          else { return false;}
        }); 
      });

      const ifSameMarket = usmarket.toString();
      let filterMarket='';
      if ((ifSameMarket.includes('true') && ifSameMarket.includes('false')) || ifSameMarket.includes('true')){
        filterMarket='true';
      } 
      return (user.email != _this.props.usertoDeactivate.email)  && !user.suspended  &&  filterMarket=='true';
    });
     
  }

  handleSearchValue(searchString){
    if(searchString && searchString.length > 2) {
      const { editUserDetails, users } = this.props;
      let matchedUsers = users.filter(user=>{
        return user.name.toLowerCase().includes(searchString.toLowerCase());
      });
      if(matchedUsers && matchedUsers.length > 0){
        this.handleSearchUsers(matchedUsers);
      }
      else{
        userService.search(searchString, null, '', true, false, null, true, 1, 50, { recordDescriptor: userDescriptor }).then(response => {
          if(searchString == response.searchText){
            const normalizedUsers = normalizeData(response);
            const filteredUsers = normalizedUsers.filter(user => user.id != editUserDetails.id);
            this.handleSearchUsers(this.getFilteredUsers(filteredUsers));
          }
        });
      }
    }else{
      this.setState({ usersList: this.props.users }, () => {
        const menu = this.createComboBoxMenu(this.tempInitialValue);
        this.setState({ menu: menu });
      });
    }
  }

  handleClick(e, something, notMouse) {
    if (e && !notMouse) {
      e.stopPropagation();
      e = this.fixupMouse(e);
      if (e.which == 1) {
        if (!this.state.menu) {
          const menu = this.createComboBoxMenu(this.tempInitialValue);
          if ((menu.props.menuOptions && menu.props.menuOptions.length > 0) || this.props.autoFocusSearchBar || (menu.props.vendorMenuOptions && menu.props.vendorMenuOptions.length > 0)) {
            this.tempInitialValue = null;
            this.setState({ menu: menu });
          }
        }
        else if(!((e.target.tagName === 'P' && e.target.className === 'menu-text') ||
        (e.target.tagName === 'INPUT' && e.target.className === 'search-input') ||
        (e.target.tagName === 'DIV' &&
        (e.target.className === 'outer-popup-container show-search-bar' ||
          e.target.className === 'popup-menu-container show-search-bar ' || 
          e.target.className === 'outer-popup-container ' ||
          e.target.className === 'popup-menu-container ')))){
          this.setState({
            usersList: this.props.users });
          this.handleCloseMenu();
        }
        this.setFocus();
      }
    }
    else {
      if (!this.state.menu) {
        const menu = this.createComboBoxMenu(this.tempInitialValue);
        if (menu.props.menuOptions.length > 0) {
          this.tempInitialValue = null;
          this.setState({ menu: menu });
        }
        else if(!(e.target.tagName === 'P' && e.target.className === 'menu-text')){
          this.handleCloseMenu();
        }
      }
      this.setFocus();
    }
  }

  createMenuItems(userList, type) {
    const { currentSelectedUser, selectedUsers } = this.props;
    let usersFiltered = this.filterUserList(userList, type);
    let menuOptions = usersFiltered ? usersFiltered.map((user) => {
      let selected = false;
      if (selectedUsers) {
        const isSelected = selectedUsers.filter(searchUser => {
          return user.id == searchUser.id;
        });
        selected = isSelected.length > 0;
      }
      else if (this.props.selectedUsers) {
        const findUser = this.props.selectedUsers.filter(searchUser => {
          return searchUser.id == user.id;
        });
        if (findUser.length > 0) {
          selected = true;
        }
      }
      else if (currentSelectedUser) {
        if (user.id == currentSelectedUser.id) {
          selected = true;

        }
        else {
          selected = false;
        }
      }
      else {
        selected = false;
      }
      const userAvatar = <UserAvatar user={user} />;
      return ({
        type: user.id, 
        name: user.name ? user.name : (user.first_name + ' ' + user.last_name), 
        user: user, 
        decoration: (this.props.useMultiTab && user.settings && user.settings.email_notifications && user.settings.email_notifications.enabled) ? emailDecoration : null,
        customIcon: userAvatar, 
        dismiss: !this.props.multiSelect, 
        selected: selected,
      });
    }) : [];

    if (!this.props.dontSortMenu) {
      menuOptions.sort((opt1, opt2) => {
        if (opt1.name && opt2.name && opt1.name.toLowerCase() < opt2.name.toLowerCase()) {
          return -1;
        }
        else if (opt1.name && opt2.name && opt1.name.toLowerCase() > opt2.name.toLowerCase()) {
          return 1;
        }
        else {
          return 0;
        }
      });
    }

    if (this.props.allowAdd) {
      menuOptions.splice(0, 0, { type: -1, name: '-- Create User --' });
    }
    return menuOptions;
  }

  createComboBoxMenu(initialValue) {
    const { menuUp, height, multiSelect, menuBelow } = this.props;
    let maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    this.menuOptions = this.createMenuItems(this.state.usersList, this.props.useMultiTab ? 'company_users' : null);
    let menu = null;
    let verticalPosition = (height ? height : menuUp ? (this.props.small ? 24 : 32) : this.props.small ? 24 : 33);
    let pointerPosition = this.props.pointerPosition ? this.props.pointerPosition : '';
    if (multiSelect && !menuBelow && !menuUp) {
      pointerPosition = 'right';
    }
    if (this.props.useMultiTab) {
      let vendorMenuOptions = this.createMenuItems(this.state.usersList, 'vendor_users');
      let allMenuOptions = this.createMenuItems(this.state.usersList, 'all', false);
      if (menuUp) {
        menu = <MultiTabUserSelectPopup
          left={0}
          bottom={verticalPosition}
          width={this.props.width}
          height={this.props.menuHeight}
          initialValue={initialValue}
          noBackground={this.props.noBackground}
          backgroundIndex={this.props.backgroundIndex}
          menuOptions={this.menuOptions}
          vendorMenuOptions={vendorMenuOptions}
          allMenuOptions={allMenuOptions}
          menuId={'userSelectionMenu' + Math.floor(Math.random() * 1000)}
          popupOnHover={false}
          handleMenuSelection={this.handleComboboxMenuSelection}
          handleMultiMenuSelection={this.handleMultiMenuSelection}
          handleClickAway={this.handleCloseMenu}
          maxHeight={maxHeight}
          multiSelect={multiSelect}
          pointerPosition={pointerPosition}
        />;
      }
      else {
        menu = <MultiTabUserSelectPopup left={0} top={verticalPosition} width={this.props.width} height={this.props.menuHeight} initialValue={initialValue}
          noBackground={this.props.noBackground}
          backgroundIndex={this.props.backgroundIndex}

          menuOptions={this.menuOptions} vendorMenuOptions={vendorMenuOptions} allMenuOptions={allMenuOptions}
          menuId={'userSelectionMenu' + Math.floor(Math.random() * 1000)} popupOnHover={false}
          handleMenuSelection={this.handleComboboxMenuSelection} handleMultiMenuSelection={this.handleMultiMenuSelection}
          handleClickAway={this.handleCloseMenu}
          maxHeight={maxHeight} multiSelect={multiSelect} pointerPosition={pointerPosition} />;
      }
    }
    else {
      if (menuUp) {
        menu = <PopupMenu left={0} bottom={verticalPosition} width={this.props.width} height={this.props.menuHeight} overrideHeight={this.props.menuHeight} initialValue={initialValue}
          backgroundIndex={this.props.backgroundIndex}
          noBackground={this.props.noBackground}
          menuOptions={this.menuOptions} size="small"
          menuId={'userSelectionMenu' + Math.floor(Math.random() * 1000)} popupOnHover={false}
          handleMenuSelection={this.handleComboboxMenuSelection} handleMultiMenuSelection={this.handleMultiMenuSelection}
          handleClickAway={this.handleCloseMenu}
          maxHeight={maxHeight} multiSelect={multiSelect} pointerPosition={pointerPosition}
          showSearchBar={this.props.showSearchBar}
          searchHint={this.props.searchHint} />;
      }
      else {
        menu = <PopupMenu left={0} top={verticalPosition} width={this.props.width} height={this.props.menuHeight} overrideHeight={this.props.menuHeight} initialValue={initialValue}
          noBackground={this.props.noBackground}
          menuOptions={this.menuOptions} size="small"
          menuId={'userSelectionMenu' + Math.floor(Math.random() * 1000)} popupOnHover={false}
          handleMenuSelection={this.handleComboboxMenuSelection} handleMultiMenuSelection={this.handleMultiMenuSelection}
          backgroundIndex={this.props.backgroundIndex}
          handleClickAway={this.handleCloseMenu}
          maxHeight={maxHeight} multiSelect={multiSelect} pointerPosition={pointerPosition}
          showSearchBar={this.props.showSearchBar}
          searchHint={this.props.searchHint}
          handleSearchValue={this.handleSearchValue}
          autoFocusSearchBar={this.props.autoFocusSearchBar} />;
      }
    }

    return menu;
  }

  handleMultiMenuSelection(multipleOptions, selectedOption) {
    const { handleMultipleSelection } = this.props;
    if (handleMultipleSelection) {
      if (selectedOption.user.all) {
        handleMultipleSelection([], selectedOption);
        this.setState({ menu: null });
      }
      else {
        handleMultipleSelection(multipleOptions.map(option => { return option.user; }), selectedOption);
      }
    }
  }

  handleComboboxMenuSelection(type, keyboardSelected, searchString) {
    const { handleSelection, multiSelect } = this.props;
    if (multiSelect) {
    }
    else {
      const optionSelectedBase = this.menuOptions.filter(option => {
        return option.type.toString() == type.toString();
      });
      let optionSelected = null;
      if (optionSelectedBase && optionSelectedBase.length > 0) {
        optionSelected = optionSelectedBase[0];
        optionSelected.selected = !optionSelected.selected;
      }
      if (!keyboardSelected) {
        this.setState({ menu: null, initialValue: '' });
        if (handleSelection) {
          handleSelection(type, optionSelected);
        }
      }
    }
    if(searchString && searchString.length > 0){
      this.setState({ usersList: this.props.users });
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleClick(e, false, true);
    }
    else if (e.keyCode == 27) {
      const { handleEscape } = this.props;
      if (handleEscape) {
        handleEscape();
      }
    }
    else if (e.keyCode == 9) {
      e.preventDefault();
    }
    else {
      if (e.key.length == 1) {
        if (!this.props.showSearchBar) {
          this.setState({ initialValue: e.key });
          this.tempInitialValue = e.key;
        }
        this.handleClick(e, false, true);
      }
    }
  }

  handleOnChange(e) {
    
  }
  
  render() {
    const { width, height, hasBorder, underlined, displayFontStyle, label, tabIndex, disabled,
      makeAbsolute, top, left, currentSelectedUser, selectedUsers, small, users, defaultText } = this.props;
    let currentOptionName = users && users.length > 0 && !defaultText ? 'None Selected' : defaultText ? defaultText : 'No Users Available';

    let multiAssigned = false;
    let user = currentSelectedUser && currentSelectedUser.email ? currentSelectedUser : this.state.usersList && this.state.usersList.length > 0 ? { id: 1, first_name: 'None', last_name: 'Selected' } : { id: 1, first_name: 'None', last_name: 'Available' };
    if (currentSelectedUser && currentSelectedUser.first_name) {
      currentOptionName = currentSelectedUser.first_name + ' ' + currentSelectedUser.last_name;
    }
    else if (selectedUsers && selectedUsers.length > 0) {
      const availUsers = selectedUsers.filter(user => {
        return user && !user.toBeDeleted;
      });
      if (availUsers.length == 1) {
        user = availUsers[0];
        currentOptionName = user.first_name + ' ' + user.last_name;
      }
      else if (availUsers.length > 1) {
        currentOptionName = this.textMap.multipleSelected;
        multiAssigned = true;
      }
    }
    else if (this.state.initialValue) {
      currentOptionName = this.state.initialValue;
    }
    else if (users) {
      users.filter(filteredUser => {
        if (!filteredUser) {
          return false;
        }
        if (filteredUser.all && !filteredUser.multiSelect) {
          currentOptionName = filteredUser.first_name;
          return true;
        }
        if (filteredUser.all && filteredUser.multiSelect) {
          currentOptionName = filteredUser.first_name;
          user = filteredUser;
          return true;
        }
        return false;
      });
    }
    let style = { width: width + 'px', height: height + 'px' };
    if (makeAbsolute) {
      style.position = 'absolute';
      style.left = left;
      style.top = top;
    }
    const boxClass = 'display-box ' + (hasBorder ? 'bordered' : '') + (underlined ? ' underlined' : '');
    const comboboxMenu = this.state.menu;
    let labelDisplay = null;
    if (label) {
      labelDisplay = <div className={'select-user-combo-box-label' + (disabled ? ' disabled' : '')}>{label}</div>;
    }
    let userAvatar = null;
    if (user) {
      userAvatar = <UserAvatar key={user.id} user={user} small={small} multiAssigned={multiAssigned} multiSelect={this.props.multiSelect}/>;
    }
    let caretEntry = null;
    if (!disabled) {
      caretEntry = <img className={'caret' + (small ? ' small' : '')} src={caret} alt="DropDown" />;
    }
    return (
      <div id={this.props.id} tabIndex={tabIndex} className="select-user-combo-box" style={style} onClick={!disabled ? this.handleClick : null}
        onKeyDown={!disabled ? this.handleKeyDown : null} ref={el => this.comboBoxRef = el}>
        <div className="popup-menu-container">
          {comboboxMenu}
        </div>
        {labelDisplay}
        <div className={boxClass}>
          <Input className="focus-box" onKeyDown={!disabled ? this.handleKeyDown : null} ref={(element) => {
            this.comboBox = element;
          }} value={currentOptionName || ''} onChange={this.handleOnChange}/>
          <div className={'selected-user-avatar' + (small ? ' small' : '')}>
            {userAvatar}
          </div>
          <div className={'selected-value' + (this.props.adjustHeight ? ' adjust-height' : '') + (small ? ' small' : '') + (disabled ? ' disabled' : '')} style={displayFontStyle}>{currentOptionName}</div>
          {caretEntry}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};
export default connect(mapStateToProps)(SelectUserComboBox);



// WEBPACK FOOTER //
// ./src/components/SelectUserComboBox/index.js